var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOmni = function SvgOmni(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 203.74 226.05",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "omni_svg__a",
    x1: 101.85,
    x2: 101.85,
    y1: -15.19,
    y2: 237.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ffb500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ff8c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ff7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ff6a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#fc4f0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f92f1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f81b27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f7142b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#df162e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#af1a38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b214c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni_svg__a",
    id: "omni_svg__b",
    x1: 24.84,
    x2: 24.84,
    y1: -15.19,
    y2: 237.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni_svg__a",
    id: "omni_svg__c",
    x1: 178.9,
    x2: 178.9,
    y1: -15.19,
    y2: 237.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni_svg__a",
    id: "omni_svg__d",
    x1: 145.06,
    x2: 145.06,
    y1: -15.19,
    y2: 237.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni_svg__a",
    id: "omni_svg__e",
    x1: 58.64,
    x2: 58.64,
    y1: -15.19,
    y2: 237.81
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.89 226.05c2.85 0 5.67-.15 8.46-.35V.35c-2.8-.21-5.62-.35-8.48-.35s-5.7.14-8.52.35v225.34c2.81.21 5.64.35 8.5.36Z",
    style: {
      fill: "url(#omni_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.56 50.9-2.44-2.43A112.82 112.82 0 0 0 .2 63.61c29.42 29.89 32.52 44.31 32.48 49.14C32.57 125 17.58 144.21 0 162a113.69 113.69 0 0 0 8.84 15.15c1-1 1.95-1.92 2.92-2.9 25.37-25.54 37.77-45.61 37.92-61.38S37.36 77 11.56 50.9Z",
    style: {
      fill: "url(#omni_svg__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 174.29 2.92 2.9a113.69 113.69 0 0 0 8.82-15.19c-17.57-17.83-32.56-37.09-32.68-49.29-.11-11.9 14.79-31.15 32.46-49.18a112.88 112.88 0 0 0-8.9-15.1l-2.44 2.43c-25.8 26.05-38.27 46.34-38.12 62s12.55 35.89 37.94 61.43Z",
    style: {
      fill: "url(#omni_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.68 112.83c0-22 9.81-58.58 24.92-93.15A113 113 0 0 0 150.45 11c-16.54 37.27-26.78 76.91-26.78 101.87 0 24.15 11.09 64.23 27.93 101.7a113 113 0 0 0 14.84-8.77c-15.59-35.07-25.76-71.73-25.76-92.97Z",
    style: {
      fill: "url(#omni_svg__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 112.83c0-25.09-10.65-64.95-27-101.76a112.76 112.76 0 0 0-14.93 8.64C53.21 54.26 63 90.85 63 112.83c0 21.23-10.17 57.88-25.76 92.91a113.66 113.66 0 0 0 14.84 8.77C68.94 177.05 80 137 80 112.83Z",
    style: {
      fill: "url(#omni_svg__e)"
    }
  }))));
};
export default SvgOmni;